import styled from 'styled-components';

const Wrapper = styled.div`
	.holla-generate-wrapper {
		.input-wrapper {
    		padding: 22px;
			width: 100%;
			.sub-header {
				color: #ffffff;
				font-size: 18px;
			}
			.white-text{
                color: #ffffff;
            }
			.ant-btn {
				height: 50px;
				margin-top: 0.5rem;
			}
			.select-wrapper {
				margin: 5px 0 10px 0;
    			width: 160px;
			}
			.general-content {
				.d-flex {
					display: flex;
    				align-items: center;
				}
				.bold {
					margin-left: 8px;
					font-weight: bold;
				}
				.disable-txt {
					color: #A8A8B1;
					margin-left: 23px;
					opacity: 0.5;
    				margin-bottom: 2rem;
				}
				.anticon {
    				font-size: 20px;
					svg {
						fill: #2727ff;
					}
				}
				.errText {
					color: #FF0000;
				}
			}
			.name-input {
    			margin: 30px 0 25px 0;
			}
			.general-wrapper {
    			display: flex;
				.anticon {
					margin: 7px 10px 0px 0px;
					font-size: 26px;
					svg {
    					fill: #2727FF;
					}
				}
			}
			.twoFA-input {
    			margin-bottom: 2rem ;
			}
			.verification-wrapper {
				.d-flex {
					display: flex;
				}
				.anticon {
					font-size: 29px;
					margin-right: 10px;
					svg {
    					fill: #fff;
					}
				}
			}
		}
		.warning-wrapper {
			padding: 0px;

			.warning-icon {
				color: #f83e18;
				font-size: 32px;
				margin: 0.25rem 0.75rem 0rem 0rem;
			}
			.warning-text {
				color: #f83e18;
			}
			.ant-btn {
				height: 30px;
				margin-top: 0.5rem;
			}
		}
		.key-confirmation {
			padding: 26px 10px 10px 10px;
		}
		.flex-content {
			display: flex;
		}
		.text-center {
			text-align: center;
		}
		.seperator {
			margin: 0.5rem;
		}
		.key-refresh-icon {
			height: 6rem;
			width: 6rem;
		}
		.ant-input:hover {
			border: 1px solid rgb(167 168 177 / 50%) !important;
			}
		.ant-input:focus{
		border: 1px solid #3A4FFF !important;
		}
	}
	@media (max-width: 1200px) {
		.holla-generate-wrapper {
			.input-wrapper {
				width: 100%;
			}
		}
	}
`;

export default Wrapper;
